// Single source of the current tenant's VENUE timezone for the admin SPA, so
// every metadata/date stamp renders in venue-local time (e.g. EDT) instead of
// UTC or the browser's zone. The venue tz comes from /api/me/tenants (resolved
// server-side from venues.timezone). Cached module-level — one fetch for the
// whole app. Per-EVENT times still use the event's own venue_timezone where
// available; this is the tenant default for everything else.

import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { apiFetch } from './api.js';

const DEFAULT_TZ = 'America/New_York';
let _map = null;        // slug -> tz
let _promise = null;

function loadMap() {
  if (_map) return Promise.resolve(_map);
  if (_promise) return _promise;
  _promise = apiFetch('/api/me/tenants')
    .then((r) => r.json())
    .then((d) => {
      _map = {};
      (d.tenants || []).forEach((t) => { _map[t.slug] = t.venue_tz || DEFAULT_TZ; });
      return _map;
    })
    .catch(() => ({}));
  return _promise;
}

export function getVenueTz(slug) {
  return (_map && _map[slug]) || DEFAULT_TZ;
}

// Hook for any admin view under /:tenantSlug/* — returns the venue tz, loading
// the map once and re-rendering when it arrives.
export function useVenueTz() {
  const { tenantSlug } = useParams();
  const [tz, setTz] = useState(() => getVenueTz(tenantSlug));
  useEffect(() => {
    let on = true;
    loadMap().then(() => { if (on) setTz(getVenueTz(tenantSlug)); });
    return () => { on = false; };
  }, [tenantSlug]);
  return tz;
}
